import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12db73fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "marking" }
const _hoisted_2 = { class: "marking-content" }
const _hoisted_3 = { class: "join" }
const _hoisted_4 = { style: {"display":"flex"} }

import { watch, ref } from 'vue'
import { isKO, useRtfix } from '@/store'
import { useStore } from 'vuex'
import { bury } from '@/util/useBury'
import { t } from '@/plugins/i18n'
import { useRoute } from 'vue-router'
import { TaEvent, taTrack } from '@/util/buryingPoint'

// const props = defineProps(['data'])

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const token = store.getters.token

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "marking-top",
      style: _normalizeStyle({ bottom: _unref(isKO)() ? '372px' : '480px' })
    }, null, 4),
    _createElementVNode("div", {
      class: "marking-bot",
      style: _normalizeStyle({ bottom: _unref(isKO)() ? '172px' : '280px' })
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(token))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('加入CKB 会员计划以查看更多信息')), 1),
              _createVNode(_component_router_link, {
                to: _unref(useRtfix)('VipLevel'),
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('会员登录')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('注册或登录以查看更多信息')), 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_button, {
                  class: "loginBtn btn",
                  onClick: _cache[0] || (_cache[0] = () => {
              _unref(taTrack)({
                event: _unref(TaEvent).PUPUP_WINDOW,
                value: {
                  position: 'login',
                  source: 'search_list'
                }
              })
              _unref(store).commit('status/onLogin', true)
            })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('登录')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("a", {
                  class: "ml_30",
                  onClick: _cache[2] || (_cache[2] = () => {
              _unref(taTrack)({
                event: _unref(TaEvent).PUPUP_WINDOW,
                value: {
                  position: 'register',
                  source: 'search_list'
                }
              })
              _unref(bury)('ALL_Click_Register')
            })
                }, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    class: "signBtn btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_unref(store).commit('status/loginPanel', 'signUp'); _unref(store).commit('status/onLogin', true)})
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('注册')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ], 64))
      ])
    ], 4)
  ]))
}
}

})